export default __webpack_public_path__ + "static/media/laundryss.9b9c354b.png";